import { useNavigate } from 'react-router'
import { useCallback, useContext } from 'react'
import useSupabase from '~/core/hooks/use-supabase'
import UserSessionContext from '~/core/session/contexts/user-session'

/**
 * @name useSignOut
 */
function useSignOut() {
  const { setUserSession } = useContext(UserSessionContext)
  const navigate = useNavigate()
  const client = useSupabase()

  return useCallback(async () => {
    await client.auth.signOut()
    setUserSession(undefined)

    // Redirect to the sign-in page
    navigate('/auth/sign-in')
  }, [client.auth, navigate, setUserSession])
}

export default useSignOut
